const pathAPI = '/api/booking';

export const apiBooking = {
	createBook: `${pathAPI}/create`,
};
